import React__default, { useRef, useState } from 'react';
import { CardMedia, CardContent, Box } from '@mui/material';
import clsx from 'clsx';
import debounce from 'lodash/debounce';
import StyledBasketElement, { classes } from './index.styled.js';

var BasketElement = function (_a) {
    var _b, _c;
    var element = _a.element, actions = _a.actions, onNavigate = _a.onNavigate, sxCard = _a.sxCard, children = _a.children, className = _a.className, _d = _a.testId, testId = _d === void 0 ? "BasketElement" : _d, id = _a.id, sx = _a.sx;
    var card = useRef(null);
    var image = useRef(null);
    var _e = useState(false), isEntered = _e[0], setIsEntered = _e[1];
    var handleKeyboardNav = function (e) {
        var _a;
        var isRootFocused = card.current === document.activeElement;
        if (!isEntered) {
            (_a = card.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // if we press enter when the root element isFocused
        if (e.key === "Enter" && isRootFocused) {
            setIsEntered(true);
            // don't trigger the event on ref,
            setTimeout(function () { var _a; return (_a = image.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 1);
        }
        // if we press espace when we're navigating into the element
        if (e.key === "Escape" && isEntered) {
            setIsEntered(false);
            // don't trigger the event on ref,
            setTimeout(function () { var _a; return (_a = card.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 1);
        }
    };
    // Debounce to avoid unwanted loose of focus between transition
    var checkFocus = debounce(function () {
        var _a;
        var isChildsFocused = (_a = card.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement);
        var isRootFocused = card.current === document.activeElement;
        if (!isChildsFocused && !isRootFocused) {
            setIsEntered(false);
        }
    }, 100);
    return (React__default.createElement(StyledBasketElement, { className: clsx("BasketElement", className), "data-testid": testId, id: id, component: "article", onKeyDown: handleKeyboardNav, ref: card, onBlur: checkFocus, onFocus: checkFocus, sx: sx },
        React__default.createElement(CardMedia, { onContextMenu: function (e) { return e.preventDefault(); }, className: classes.image, image: element === null || element === void 0 ? void 0 : element.previewUrl, title: (!Array.isArray((_b = element === null || element === void 0 ? void 0 : element.title) === null || _b === void 0 ? void 0 : _b.value) && ((_c = element === null || element === void 0 ? void 0 : element.title) === null || _c === void 0 ? void 0 : _c.value)) || "", component: "button", onClick: onNavigate, ref: image, sx: sxCard },
            React__default.createElement("span", null)),
        React__default.createElement(CardContent, { className: classes.cardContent },
            children,
            actions && React__default.createElement(Box, { className: classes.actions }, actions))));
};

export { BasketElement as default };
//# sourceMappingURL=index.js.map
